import register from '../../../../global/js/registry';
export default register('o-service-order-booking-form', () => import(/* webpackMode: "lazy" */ './o-service-order-booking-form.controller'));
